import FacetedSearch from './FacetedSearch';

export default FacetedSearch;
